<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div fluid>
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-radio-group @input="listaFiscal" id="tipo" v-model="datoFiscal.tipoPersona"
                                name="tipo">
              <b-form-radio :value="2">Fisica</b-form-radio>
              <b-form-radio :value="1">Moral</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label for="rfc">RFC
              <validacion/>
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input id="rfc" name="rfc" placeholder="RFC"
                            v-model="$v.datoFiscal.rfc.$model"
                            @input="datoFiscal.rfc = datoFiscal.rfc.toUpperCase()"
                            :state="validateState('rfc')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label for="regimen">Regimen Fiscal
              <validacion/>
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-select id="regimen" name="regimen" placeholder="Regimen Fiscal"
                             v-model="$v.datoFiscal.regimenFiscal.$model"
                             :options="regimenFiscales"
                             value-field="idRegimenFiscal"
                             text-field="nombre"
                             :state="validateState('regimenFiscal')"
              ></b-form-select>

            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="datoFiscal.tipoPersona === 2">
        <b-col>
          <b-form-group>
            <label for="nombre">Nombre(s)
              <validacion/>
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input v-model="$v.datoFiscal.nombre.$model"
                            :state="validateState('nombre')"
                            id="nombre" name="rfc" placeholder="Nombre"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="datoFiscal.tipoPersona === 1">
        <b-col>
          <b-form-group>
            <label for="nombre">Nombre de la Razón Social
              <validacion/>
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input v-model="$v.datoFiscal.nombreCompleto.$model"
                            :state="validateState('nombreCompleto')"
                            id="nombre" name="rfc" placeholder="Nombre"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="datoFiscal.tipoPersona === 2">
        <b-col>
          <b-form-group>
            <label for="paterno">Apellido paterno
              <validacion/>
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input id="paterno" name="paterno" placeholder="Apellido paterno"
                            v-model="$v.datoFiscal.paterno.$model"
                            :state="validateState('paterno')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label for="materno">Apellido materno
              <validacion/>
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input id="materno" name="materno" placeholder="Apellido materno"
                            v-model="$v.datoFiscal.materno.$model"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label for="correo">Correo electrónico
              <validacion/>
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="email" id="correo" name="correo" placeholder="Correo"
                            v-model="$v.datoFiscal.correo.$model"
                            :state="validateState('correo')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5>Dirección <span class="text-secondary"><small>(Opcional)</small></span></h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label for="calle">Calle
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input id="calle" name="calle" placeholder="Calle" v-model="datoFiscal.calle"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label for="numero">Número
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input id="numero" name="numero" placeholder="Número" v-model="datoFiscal.numero"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label for="cp">CP
              <validacion></validacion>
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input id="cp" name="cp" placeholder="CP" v-model="$v.datoFiscal.cp.$model"
                            :state="validateState('cp') && localidades.length > 0"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group align="left">
            <label for="colonia">Colonia </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="filter-square"></b-icon>
              </b-input-group-prepend>
              <v-select
                  id="colonia"
                  style="width: 90%"
                  name="colonia"
                  :options="localidades"
                  label="nombreLocalidad"
                  placeholder="Selecciona una colonia"
                  v-model="$v.datoFiscal.colonia.$model"
                  :reduce="(nom) => nom.nombreLocalidad"
              ></v-select>
            </b-input-group>
            <b-form-invalid-feedback
                v-if="tieneCp && localidades.length > 0"
                :state="datoFiscal.colonia != null">
              Selecciona una colonia
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label for="pais">País de residencia
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input id="pais" name="pais" placeholder="País" v-model="datoFiscal.pais"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label for="estado">Estado
            </label>
            <b-input-group size="sm" class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="menu-button-wide"></b-icon>
              </b-input-group-prepend>
              <b-form-input id="estado" name="estado" placeholder="Estado" v-model="datoFiscal.estado"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="text-center">
        <b-button  variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button
            class="ml-2"
            variant="outline-danger"
            @click="$bvModal.hide('showDatosFiscales')"
        >Cancelar
        </b-button>

      </div>
    </div>
  </div>
</template>

<script>
import {email, maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
export default {
  props:{
    datosFactura:{
      idEmpresa: Number,
      idCuenta :  Number,
      idPlan: Number,
      numerofacturas:  Number,
      idArchivo: Number
    },
    editar: Boolean,
    fiscales: Object,
    },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    lstRfc:[],
    rfcSeleccionado: null,
    nombreRazonSocial: null,
    correoElectronico:null,
    listadoCfi:[],
    cfdiSeleccionado: null,
    loaderFacturar: false,
    datoFiscal: {
      idPaciente: null,
      idDatosFiscales: null,
      nacionalidad: null,
      rfc: null,
      tipoPersona: 2,
      nombre: null,
      nombreCompleto: null,
      paterno: null,
      materno: null,
      calle: null,
      numero: null,
      colonia: null,
      cp: null,
      pais: null,
      estado: null,
      correo: null,
      idCuenta: null,
      idArchivo: null,
      regimenFiscal: null,
      idPlan: null,
      editar: null
    },
    blnLoaderRFC: false,
    blnLoaderRazonSocial: false,
    blnLoaderCorreo: false,
    blnLoaderUsoCDFI: false,
    blnDatosFiscalesFacturar:true,
    loaderAcciones: false,
    rfcSeleccionadoAux: null,
    metodoPago: "",
    regimenFiscales: [],
    codigoPostalSeleccionado : null,
    regimenFiscalSeleccionado: null,
    localidades: [],
    tieneCp: false
  }),
  mounted(){
    this.listaFiscal();
    if (this.editar){
      this.datoFiscal = this.fiscales;
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  validations() {
    if(this.datoFiscal.tipoPersona === 2){
      return {
        datoFiscal: {
          rfc: {required, minLength: minLength(13), maxLength: maxLength(13)},
          regimenFiscal: {required},
          nombre: {required},
          paterno: {required},
          materno: {},
          correo: {required,email},
          cp: {
            numeric,
            minLength: minLength(5),
            maxLength: maxLength(5),
            required,
          },
          colonia: { required }
        }
      }
    } else {
      return {
        datoFiscal: {
          rfc: {required, minLength: minLength(12), maxLength: maxLength(12)},
          regimenFiscal: {required},
          nombreCompleto: {required},
          correo: {required,email},
          cp: {
            numeric,
            minLength: minLength(5),
            maxLength: maxLength(5),
            required,
          },
          colonia: { required }
        }
      }
    }
  },
  methods: {
    validateState(name)
    {
      const {$dirty, $error} = this.$v.datoFiscal[name];
      return $dirty ? !$error : null;
    },
    nombre(){
      if(this.datoFiscal.tipoPersona === 1){
        this.datoFiscal.nombre = "";
        this.datoFiscal.paterno = "";
        this.datoFiscal.materno = "";
        this.datoFiscal.nombreCompleto = this.datoFiscal.nombreCompleto.trimStart();
        this.datoFiscal.nombreCompleto = this.datoFiscal.nombreCompleto.trimEnd();
      }else{
        this.datoFiscal.nombre = this.datoFiscal.nombre.trim();
        this.datoFiscal.paterno = this.datoFiscal.paterno.trim();
        if(this.datoFiscal.materno != null){
          this.datoFiscal.materno = this.datoFiscal.materno.trim();
        }
      }
    },
    guardar() {
      if (this.datoFiscal.rfc !== "XAXX010101000") {

        this.$v.datoFiscal.$touch();
        if (this.$v.datoFiscal.$anyError) {
          this.$swal({
            icon: "warning",
            text: "Debe llenar los campos obligatorios",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          return;
        }
        if (!this.$v.datoFiscal.$invalid) {
          this.loaderAcciones = true;
          this.nombre();
          this.datoFiscal.idPlan = this.$route.params.id;
          this.datoFiscal.editar = this.editar;
          this.$http
              .post(this.$api + "portalautoservicio/guardar/datosFiscalesPlan", this.datoFiscal)
              .then((respuesta) => {
                if (respuesta.data.success) {
                  this.obtenerListaRfc();
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "Se registró correctamente",
                  });
                }
              })
              .catch( (reason) => {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: reason.response.data.message,
                });
              })
              .finally(() => {
                this.loaderAcciones = false;
              });
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "RFC no válido para una cuenta",
        });
      }
    },
    obtenerListaRfc() {
      this.$emit("obtenerListaRfc")
    },

    obtenerCodigoUsoFactura() {
      this.cfdiSeleccionado = null;
      this.listadoCfi = [];
      let fisica;
      let moral;
      if(this.rfcSeleccionadoAux.length === 13){
        fisica = true;
        moral = false;
      }else if (this.rfcSeleccionadoAux.length === 12){
        fisica = false;
        moral = true;
      }
      if(this.rfcSeleccionadoAux.length >= 12){
        this.blnLoaderUsoCDFI = true;
        const url= this.$baseBack + "/api/erp/portal/codigoUsoFactura?personaFisica="+fisica+"&personaMoral="+moral;
        this.$http
            .get(url)
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.listadoCfi = respuesta.data.data;
              }
            })
            .finally(() => {
              this.blnLoaderUsoCDFI = false;
            });
      }
    },
    realizarFactura(){
      const datosEnviar = {
        idEmpresa: this.datosFactura.idEmpresa,
        idCuenta: this.datosFactura.idCuenta,
        idRfc: this.rfcSeleccionado,
        rfc:this.rfcSeleccionadoAux,
        razonSocialPaciente: this.nombreRazonSocial,
        correoPaciente:this.correoElectronico,
        listaProductos: null,
        codigoUsoDeFactura: this.cfdiSeleccionado,
        codigoFormaDePago: this.metodoPago,
        fechaFactura: this.$moment(new Date()).format("YYYY-MM-DD"),
        idPlan: this.datosFactura.idPlan,
        horas: this.$horas(),
        idArchivo: this.datosFactura.idArchivo,
        cp: this.codigoPostalSeleccionado,
        regimen: this.regimenFiscalSeleccionado
      }
      if(this.datosFactura.idArchivo === null){
        this.loaderFacturar = true;
        this.$http
            .post(this.$api +"portalautoservicio/ajusteanual/facturacion",datosEnviar)
            .then((response) => {
              if(response.status == 200 && (response.data.data.error === false)){
                window.open(response.data.data.ligaFactura, '_blank');
                this.$swal({
                  icon: "success",
                  title: `${response.data.data.mensaje}`,
                  confirmButtonText: "Ok",
                }).then(() => {
                })
              }else{
                this.mostrarMensaje(response.data.data.mensaje);
              }
            })
            .catch(function (error) {
              console.error(error);
            })
            .finally(() => {this.loaderFacturar = false;});
      }else{
        this.loaderFacturar = true;
        this.$http
            .post(this.$api +"portalautoservicio/administracionpoblacion/facturacion",datosEnviar)
            .then((response) => {
              if(response.status == 200 && (response.data.data.error === false)){
                window.open(response.data.data.ligaFactura, '_blank');
                this.$swal({
                  icon: "success",
                  title: `${response.data.data.mensaje}`,
                  confirmButtonText: "Ok",
                }).then(() => {
                })
              }else{
                this.mostrarMensaje(response.data.data.mensaje);
              }
            })
            .catch(function (error) {
              console.error(error);
            })
            .finally(() => {this.loaderFacturar = false;});
      }
    },
    mostrarMensaje(mensaje) {
      this.$swal({
        icon: "error",
        title: `${mensaje}`,
        confirmButtonText: "Ok",
      });
    },
    listaFiscal() {
      const parametros = {idTipoPersona: this.datoFiscal.tipoPersona}
      this.$http.post(this.$api + 'catalogos/regimenFiscal/obtener/activo',parametros,{ 'headers': { 'Authorization': this.headers}}).then(respuesta => {
        if (respuesta.data.data) {
          this.regimenFiscales = respuesta.data.data;
        }
      })
          .catch((err) => {
            this.mostrarMensaje(err);
          });
    },
    buscarCp() {
      const params = {
        codigoPostal: this.datoFiscal.cp
      }
      this.$http
          .post(this.$api + "localidad/postales", params)
          .then((respuesta) => {
            if (respuesta.status === 200) {
              if (respuesta.data.data.length > 0) {
                this.localidades = respuesta.data.data;
                this.datoFiscal.estado = this.localidades[0].nombreEstado;
                this.datoFiscal.pais = "MÉXICO";
              }
            }
          });
    },
  },
  watch: {
    "datoFiscal.cp": function () {
      if (this.datoFiscal.cp.length === 5) {
        this.tieneCp = true;
        this.buscarCp();
      } else {
        this.tieneCp = false;
        this.localidades = [];
        this.datoFiscal.colonia = null;
        this.datoFiscal.estado = null;
        this.datoFiscal.pais = null;
      }
    },
  },
}
</script>

<style scoped>
</style>